export const trackFacebookEvent = (customName, prefix = 'Event', data=undefined) => {
  if (window.fbq) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    if (!!customName) {
      window.fbq('trackCustom', `${prefixWithBrackets} ${customName}`, data);
    } else {
      window.fbq('trackCustom', `${prefix}`, data);
    }
  }
};

export const trackGoogleEvent = (customName, prefix = 'Event', data=undefined) => {
  if (window.gtag) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    // @see https://support.google.com/analytics/answer/9267735?hl=pt-BR
    if (!!customName) {
      window.gtag('event', `${prefixWithBrackets} ${customName}`, data);
    } else {
      window.gtag('event', `${prefix}`, data);
    }
  }
};

export const trackFacebookSubmission = (channelId, customName, page, prefix = 'Submit') => {
  if (window.fbq) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    // @see https://www.facebook.com/business/help/402791146561655?id=1205376682832142
    if (!!customName) {
      window.fbq('track', 'Lead', {content_name: customName});
      window.fbq('trackCustom', `${prefixWithBrackets} ${customName}`);
    } else {
      window.fbq('track', 'Lead', {content_name: channelId});
      window.fbq('trackCustom', `${prefixWithBrackets} ${channelId}`);
    }

    window.fbq('trackCustom', `[${prefix}Page] "${page}"`);
  }
};

export const trackGoogleSubmission = (channelId, customName, page, prefix = 'Submit') => {
  if (window.gtag) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    // @see https://support.google.com/analytics/answer/9267735?hl=pt-BR
    if (!!customName) {
      window.gtag('event', `${prefixWithBrackets} ${customName}`);
    } else {
      window.gtag('event', `${prefixWithBrackets} ${channelId.replaceAll('-', '_')}`);
    }
    window.gtag('event', `[${prefix}Page] "${page}"`);
  }
};

// Send button click of form submission events to marketing tools.
export const trackSubmission = (channelId, customFbName, customGoogleName, page) => {
  trackFacebookSubmission(channelId, customFbName, page);
  trackGoogleSubmission(channelId, customGoogleName, page);
};

export const trackFacebookConversion = (channelId, customName, page, prefix = 'Lead') => {
  if (window.fbq) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    // @see https://www.facebook.com/business/help/402791146561655?id=1205376682832142
    window.fbq('track', 'CompleteRegistration', {content_name: channelId});
    window.fbq('trackCustom', `${prefixWithBrackets} ${channelId}`);

    if (!!!customName) {
      window.fbq('track', 'CompleteRegistration', {content_name: customName});
      window.fbq('trackCustom', `${prefixWithBrackets} ${customName}`);
    }

    window.fbq('trackCustom', `[${prefix}Page] "${page}"`);
  }
};

export const trackGoogleAdsConversion = (id, label) => {
  const gAdsId = !id.startsWith('AW-') ? `AW-${id}` : id

  if (window.gtag) {
    const options = {
      send_to: `${gAdsId}/${label}`,
    }

    window.gtag('event', `conversion`, options);
  }
};

const trackGoogleConversion = (channelId, customName, page, prefix = 'Lead') => {
  if (window.gtag) {
    const prefixWithBrackets = prefix && prefix.length > 0 ? `[${prefix}]` : '';
    // @see https://support.google.com/analytics/answer/9267735?hl=pt-BR
    if (!!customName) {
      window.gtag('event', `${prefixWithBrackets} ${customName}`);
    } else {
      window.gtag('event', `${prefixWithBrackets} ${channelId.replaceAll('-', '_')}`);
    }

    window.gtag("event", "generate_lead", {
      currency: "BRL",
      value: 1
    });

    window.gtag('event', `[${prefix}Page] "${page}"`);
  }
};

/**
 *  Send valid form submission events to marketing tools.
 *
 * @param channelId the channel id from evag.io.
 * @param customFbName the custom name in the submission event to be sent to Meta.
 * @param customGoogleName the custom name in the submission event to be sent to Google.
 * @param page the page where the event occurred.
 * @param gAdsConversion the Google Ads conversion configuration object.
 */
export const trackConversion = (channelId, customFbName, customGoogleName, page, gAdsConversion) => {
  trackFacebookConversion(channelId, customFbName, page);
  trackGoogleConversion(channelId, customGoogleName, page);
  if (!!gAdsConversion) {
    trackGoogleAdsConversion(gAdsConversion.id, gAdsConversion.label);
  }
};

export const clickEvent = "Click"

/**
 * Send button click events to marketing tools.
 *
 * @param customName the custom name of the event to be sent.
 */
export const trackClick = (customName) => {
  const prefix = clickEvent;
  trackFacebookEvent(customName, prefix);
  trackGoogleEvent(customName, prefix);
};

/**
 * Send menu click events to marketing tools.
 *
 * @param customName the custom name of the event to be sent.
 */
export const trackMenuClick = (customName) => {
  const prefix = "Menu";
  trackFacebookEvent(customName, prefix);
  trackGoogleEvent(customName, prefix);
};

/**
 * Send share button click events to marketing tools.
 *
 * @param socialNetwork the social network name of the event to be sent.
 * @param url the page url related to the sharing event.
 * @param title the page title related to the sharing event.
 */
export const trackShare = (socialNetwork, url, title) => {
  const prefix = `${socialNetwork} Share`;
  trackFacebookEvent(null, prefix, {url});
  trackGoogleEvent(null, prefix, {pageLocation: url, pageTitle: title});
};

/**
 * Send search events to marketing tools.
 *
 * @param query the query.
 */
export const trackSearch = (query) => {
  const prefix = "Search";
  trackFacebookEvent(query, prefix);
  trackGoogleEvent(query, prefix);
};
